import { getNewYorkNow } from './timeSlots.js';

const dateKey = (value) => value ? String(value).slice(0, 10) : '';

// Purchase dates are New York calendar dates, including the whole final day.
// Shared by the storefront, coupon validation and authoritative server pricing.
export function isCouponLive(coupon, now = new Date()) {
  if (!coupon || coupon.is_active === 0 || coupon.is_active === false) return false;
  const today = getNewYorkNow(now).dateString;
  if (coupon.valid_from && today < dateKey(coupon.valid_from)) return false;
  if (coupon.valid_until && today > dateKey(coupon.valid_until)) return false;
  if (coupon.booking_date_until && today > dateKey(coupon.booking_date_until)) return false;
  const cap = coupon.max_uses;
  return cap == null || Number(coupon.used_count || 0) < Number(cap);
}
